import { Component, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'custom-grid-header',
  templateUrl: './custom-header-icon.component.html',
  styleUrls: ['./custom-header-icon.component.css'],
  standalone: false
})
export class CustomHeaderIconComponent {
  public params: any;

  agInit(params): void {
    this.params = params;
  }
}
